var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		'c-swiper-wrap',
		{
			'opacity-100': _vm.isLoaded,
		},
	]},[(_vm.items.length > 1)?_c('div',{staticClass:"c-swiper-wrap__live-region",attrs:{"role":"status"},domProps:{"textContent":_vm._s(_vm.screenReaderText)}}):_vm._e(),_vm._v(" "),_vm._t("custom",function(){return [_vm._t("before",null,null,_vm.slotBindings),_vm._v(" "),_c('div',{ref:"content",class:['c-swiper-wrap__content', _vm.itemsWrapperClassNames],on:{"wheel":_vm.updateCurrent,"scroll":_vm.updateCurrent,"touchmove":_vm.updateCurrent,"touchend":_vm.updateCurrent,"focusin":_vm.goToFocused}},[_vm._t("items",null,null,_vm.slotBindings)],2),_vm._v(" "),_vm._t("default",null,null,_vm.slotBindings)]},null,_vm.slotBindings)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }